module.exports = __webpack_public_path__ + "img/empty-search.9bf3914c.svg";